import { Base } from 'domains/Base';

interface IShareItem {
  url: string;
}

export interface IShare {
  whatsapp: IShareItem;
  facebook: IShareItem;
  twitter: IShareItem;
  email: IShareItem;
}

export enum AdType {
  FOR_SALE = 'for-sale',
  WANTED = 'wanted',
  C2B = 'c2b',
}

export interface Ad extends Base {
  section?: string;
  parentSection?: string;
  friendlyUrl: string | null;
  share: IShare | null;
  adType: AdType[];
}
